let initialState = {
    name: "YARA TECH LLC",
    telephone: "503-933-4923",
    email: "yaratechsoftware@gmail.com",
}

const firmReducer = (state = initialState, action) => {
    switch (action.type) {

        default:
            return state;
    }
}

export default firmReducer;